import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../component/layout';
import DashboardTab from './tabs/dashboardTab';
import GeneratorTab from './tabs/generatorTab';
import WaterTab from './tabs/waterTab';
import ElectricityTab from './tabs/electricityTab';
import AlertsTab from './tabs/alertsTab';

const CommonAreaUtility = () => {
  // Tabs: 0 = Dashboard, 1 = Generator, 2 = Water, 3 = Electricity, 4 = Alerts
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Layout title="Common Area Utility">
      <div className="page-header">
        <div className="page-block">
          <div className="row align-items-center">
            <div className="col-md-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to={"/core/dashboard/"}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={""}>Common Area Utility Management</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid p-0">
        <div className="row mb-4">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h4 className="mb-0">Common Area Utility Management</h4>
              </div>
              <div className="card-body">
                {/* Tabs */}
                <div className="mb-4">
                  <div className="card">
                    <div className="card-body py-0">
                      <ul className="nav nav-tabs profile-tabs" id="myTab" role="tablist">
                        <li className="nav-item">
                          <button
                            className={`nav-link ${activeTab === 0 ? 'active' : ''}`}
                            onClick={() => setActiveTab(0)}
                            role="tab"
                          >
                            <i className="ti ti-dashboard me-2"></i>Dashboard
                          </button>
                        </li>
                        <li className="nav-item">
                          <button
                            className={`nav-link ${activeTab === 1 ? 'active' : ''}`}
                            onClick={() => setActiveTab(1)}
                            role="tab"
                          >
                            <i className="ti ti-engine me-2"></i>Generator
                          </button>
                        </li>
                        <li className="nav-item">
                          <button
                            className={`nav-link ${activeTab === 2 ? 'active' : ''}`}
                            onClick={() => setActiveTab(2)}
                            role="tab"
                          >
                            <i className="ti ti-droplet me-2"></i>Water
                          </button>
                        </li>
                        <li className="nav-item">
                          <button
                            className={`nav-link ${activeTab === 3 ? 'active' : ''}`}
                            onClick={() => setActiveTab(3)}
                            role="tab"
                          >
                            <i className="ti ti-bulb me-2"></i>Electricity
                          </button>
                        </li>
                        <li className="nav-item">
                          <button
                            className={`nav-link ${activeTab === 4 ? 'active' : ''}`}
                            onClick={() => setActiveTab(4)}
                            role="tab"
                          >
                            <i className="ti ti-alert-triangle me-2"></i>Alerts
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Tab content */}
                <div>
                  {activeTab === 0 && <DashboardTab />}
                  {activeTab === 1 && <GeneratorTab />}
                  {activeTab === 2 && <WaterTab />}
                  {activeTab === 3 && <ElectricityTab />}
                  {activeTab === 4 && <AlertsTab />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CommonAreaUtility;